<div class="close-div"><button mat-button [mat-dialog-close]=""  cdkFocusInitial><mat-icon>close</mat-icon></button></div>
<h1 mat-dialog-title>Para {{data[0]}}</h1>
<div mat-dialog-content [innerHtml]="content"></div>
<div mat-dialog-actions>  
  <button mat-button [mat-dialog-close]="" class="button-close" cdkFocusInitial>Close</button>
</div>